import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import ErrorNotFound from '@/components/Global/ErrorNotFound'

import UserRouter from '@/components/User/router'
import SecurityRouter from '@/components/Security/router'
import RoleRouter from '@/components/Role/router'
import ProductRouter from '@/components/Product/router'
import ProductFamilyRouter from '@/components/ProductFamily/router'
import OrderRouter from '@/components/Order/router'
import CartRouter from '@/components/Cart/router'
import StockRouter from '@/components/Stock/router'
import ReapproRouter from '@/components/Reappro/router'
import AgencyRouter from '@/components/Agency/router'
import ImputationRouter from '@/components/Imputation/router'
import VehicleRouter from '@/components/Vehicle/router'
import GroupRouter from '@/components/Group/router'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Home',
    component: Home
  }].concat(
    SecurityRouter,
    UserRouter,
    RoleRouter,
    ProductRouter,
    ProductFamilyRouter,
    OrderRouter,
    CartRouter,
    StockRouter,
    ReapproRouter,
    AgencyRouter,
    ImputationRouter,
    VehicleRouter,
    GroupRouter,
  ).concat([{
    path: '*',
    name: 'ErrorNotFound',
    component: ErrorNotFound
  }]),
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
})


export default router



// WEBPACK FOOTER //
// ./src/Router.js